import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/Card.tsx';
import { columnLabelClass } from '@/components/ui/typography.ts';

interface ClientAcceptanceNotePanelProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  /** Odstępy treści — panele różnią się nimi, ramka i nagłówek nie. */
  contentClassName?: string;
}

/** Skorupa panelu objaśnień obok podglądu: nagłówek nad treścią. */
const ClientAcceptanceNotePanel = ({
  title,
  contentClassName,
  children,
  className,
  ...props
}: ClientAcceptanceNotePanelProps) => (
  <Card className={cn('overflow-hidden', className)} {...props}>
    <div
      className={cn(
        'border-b border-neutral-100 px-5 pb-3.5 pt-4',
        columnLabelClass,
      )}
    >
      {title}
    </div>
    <div className={cn('flex flex-col px-5 pb-[18px]', contentClassName)}>
      {children}
    </div>
  </Card>
);

export default ClientAcceptanceNotePanel;
